import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { logout } from "../../actions";
import { AuthState } from "../../models";
import {
    LogoutButton as Presenter,
    LogoutButtonDispatchProps,
} from "./presenter";

// Map the action to the component
function mapDispatchToProps(dispatch: Dispatch<AuthState>) {
    return {
        logout: bindActionCreators(logout, dispatch),
    } as LogoutButtonDispatchProps;
}

// Connect the component to Redux.
const LogoutButton = connect(null, mapDispatchToProps)(Presenter);

export { LogoutButton };
